import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "width_wrap" }
const _hoisted_3 = { class: "body_content" }
const _hoisted_4 = { class: "menu-A-list-wrap" }

import Talent_Items from "@/views/product/activity/Talent_Items.vue";
import BoardNavbar from "@/views/product/activity/Navbar.vue";
import Banner from "@/components/Banner.vue";
import { watch } from "vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";
import { useRouter } from "vue-router";
import { useAuth } from "@/composables/useAuth";
import { useAlertDialog } from "@/composables/useAlert";

export default /*@__PURE__*/_defineComponent({
  __name: 'Talent',
  setup(__props) {

const useAlert = useAlertDialog();
const { isLoggedIn } = useAuth();
const router = useRouter();
watch(
  isLoggedIn,
  async (newValue) => {
    if (newValue === false) {
      await useAlert("회원전용 페이지 입니다. 로그인 후 이용해주세요.");
      // TODO : 단순히 뒤로 갈지 향후 확인 후 변경 가능.
      // router.back();
      router.push({ name: USER_ROUTES.Home.Name });
    }
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  return (_unref(isLoggedIn))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(Banner, {
          title: "Activity",
          subtitle: "Activity",
          description: "학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>\n        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
        }),
        _createVNode(BoardNavbar),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[0] || (_cache[0] = _createElementVNode("h1", { class: "sub_subject" }, "재능진로전공직업 탐색 프로젝트", -1)),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(Talent_Items)
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})